import { lazy } from 'react';
import { authRoles } from 'src/app/auth';

const ServerConfigurationsApp = lazy(() => import('./ServerToolsApp'));

const ServerConfigurationsAppConfig = {
    settings: {
        layout: {},
    },
    auth: authRoles.admin,
    routes: [
        {
            path: 'apps/server-managgment/configurations',
            element: <ServerConfigurationsApp />,
        }
    ],
};

export default ServerConfigurationsAppConfig;
